import { Fragment } from "react";
import { Grid, Typography, MenuItem } from "@mui/material";
import { LoadingButton } from "@mui/lab";

import { Label, TextField } from "../../components";

export default function FormDisplay({ formikProps }) {
  return (
    <Fragment>
      <Grid item container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h5" fontWeight={600} align="center">
            SIGN UP
          </Typography>
        </Grid>

        <Grid item xs={6}>
          <Label
            required
            title="First Name"
            name="first_name"
            formikProps={formikProps}
          />
          <TextField
            required
            size="small"
            name="first_name"
            placeholder="First Name"
            formikProps={formikProps}
          />
        </Grid>

        <Grid item xs={6}>
          <Label title="Last Name" name="last_name" formikProps={formikProps} />
          <TextField
            // required
            size="small"
            name="last_name"
            placeholder="Last Name"
            formikProps={formikProps}
          />
        </Grid>

        <Grid item xs={12}>
          <Label
            required
            title="Phone no"
            name="phoneno"
            formikProps={formikProps}
          />
          <TextField
            required
            size="small"
            name="phoneno"
            placeholder="Phone Number"
            disabled={true}
            formikProps={formikProps}
          />
        </Grid>

        <Grid item xs={12}>
          <Label
            required
            title="Gender"
            name="gender"
            formikProps={formikProps}
          />
          <TextField
            select
            required
            size="small"
            name="gender"
            placeholder="Gender"
            formikProps={formikProps}
          >
            {[
              { id: "male", name: "Male" },
              { id: "female", name: "Female" },
            ].map((item, index) => (
              <MenuItem key={index} value={item.id}>
                {item.name}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item xs={12}>
          <Label
            required
            title="Email ID"
            name="email"
            formikProps={formikProps}
          />
          <TextField
            required
            size="small"
            name="email"
            disabled={true}
            placeholder="john@sample.com"
            formikProps={formikProps}
          />
        </Grid>

        <Grid item xs={12}>
          <Label
            required
            title="User Name"
            name="username"
            formikProps={formikProps}
          />
          <TextField
            required
            size="small"
            name="username"
            placeholder="User Name"
            formikProps={formikProps}
          />
        </Grid>

        <Grid item xs={12}>
          <Label
            required
            title="Password"
            name="password1"
            formikProps={formikProps}
          />
          <TextField
            required
            size="small"
            name="password1"
            placeholder="Password"
            formikProps={formikProps}
          />
        </Grid>

        <Grid item xs={12}>
          <Label
            required
            title="Confirm Password"
            name="password2"
            formikProps={formikProps}
          />
          <TextField
            required
            size="small"
            name="password2"
            placeholder="Confirm Password"
            formikProps={formikProps}
          />
        </Grid>

        <Grid item xs={12} mt={3}>
          <LoadingButton
            type="submit"
            variant="contained"
            fullWidth
            loading={formikProps.isSubmitting}
            disabled={!formikProps.dirty || !formikProps.isValid}
          >
            Sign Up
          </LoadingButton>
        </Grid>
      </Grid>
    </Fragment>
  );
}
